/**
 * Represents the various states the authentication type can be in.
 *
 * @public
 */
export enum AuthStateType {
  LOGGED_IN = 'logged-in',
  LOGGING_IN = 'logging-in',
  ERROR = 'error',
  LOGGED_OUT = 'logged-out',
}
